import { Image } from "@/components/common/Image"
import { Popover } from "@/components/Popover"
import { ClientType, ExClient, selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import { LogOut, Settings, ShieldCheck, User } from "lucide-react"
import { FormattedMessage, useIntl } from "react-intl"
import { Link } from "react-router-dom"
import { Fragment } from "react/jsx-runtime"

export const SidebarAccountUser = ({ onAction }: { onAction: VoidFunction }) => {
  const intl = useIntl()
  const { email, first_name, last_name, is_verified, client_type, company_name } = useStoreClient(selectUser)
  const isCorporateAccount = client_type === ClientType.Coroporate
  const username = `${first_name} ${last_name}`
  const photo = is_verified ? "account.svg" : "qr.jpg"
  const status = intl.formatMessage({
    id: is_verified ? "verified" : "unverified",
  })

  return (
    <>
      <Popover
        className="border-none !mt-2"
        placement="top-start"
        target={
          <div className="account-sidebar_header">
            <div className="account-sidebar_image border">
              <Image src={photo} />
            </div>
            <div className="account-sidebar_text flex-1">
              <div className="flex items-center gap-2">
                <span>{isCorporateAccount ? company_name : username} </span>
                <Image src="verif.svg" className="h-4" />
              </div>
              <div className="account-sidebar_status">
                {status}

                <Image src="/drop.svg" style={{ marginLeft: 8 }} />
              </div>
            </div>
            {/* <div className="hover:bg-gray-200 w-8 h-8 grid place-items-center">
              <Image src="dot3.svg" className="rotate-90" />
            </div> */}
          </div>
        }
      >
        {(close) => (
          <Fragment>
            <div
              className="user-dropdown"
              onClick={() => {
                close()
                onAction()
              }}
            >
              <div className="user-dropdown__header">
                <div>
                  <span className="user__name">{isCorporateAccount ? company_name : username}</span>
                  <span className="user__status-acc">{email}</span>
                </div>
              </div>
              <div className="user-dropdown__menu">
                <div>
                  <Link to={`/verifications/exchange`}>
                    <User size={18} />
                    <FormattedMessage id="view_profile" />
                  </Link>
                </div>
                <div>
                  <Link to={`/verifications/exchange/${isCorporateAccount ? "corporate" : "personal"}-details`}>
                    <ShieldCheck size={18} />
                    <FormattedMessage id="verification" />
                  </Link>
                </div>
                <div>
                  <Link to="/settings/two-factor">
                    <Settings size={18} />
                    <FormattedMessage id="settings" />
                  </Link>
                </div>
              </div>
              <button onClick={async () => await ExClient.logout()}>
                <LogOut size={18} />
                <FormattedMessage id="logout" />
              </button>
            </div>
          </Fragment>
        )}
      </Popover>
    </>
  )
}
